import { Responsive } from '@cian/ui-kit';
import * as React from 'react';

import { GeoSuggestDesktop } from './components/GeoSuggestDesktop';
import { GeoSuggestMobile } from './components/GeoSuggestMobile';
import { IGeoSuggestProps } from './types';

export const GeoSuggest: React.FC<IGeoSuggestProps> = props => (
  <>
    <Responsive desktop>
      <GeoSuggestDesktop {...props} />
    </Responsive>
    <Responsive phone tablet>
      <GeoSuggestMobile {...props} />
    </Responsive>
  </>
);
